import { Box } from '@mui/material';
import { generateSourceHandleId } from '@utils/flows';
import React, { useRef } from 'react';
import { Handle, Position } from 'reactflow';

type Props = {
	parentId: string;
	selected: boolean;
	interactionId: string;
	color: string;
	isConnected: boolean;
};

export default ({
	parentId,
	interactionId,
	selected,
	color,
	isConnected
}: Props) => {
	const handleId = generateSourceHandleId(parentId, interactionId);

	const ref = useRef<HTMLDivElement | null>(null);

	return (
		<Handle
			ref={ref}
			type="source"
			position={Position.Right}
			data-testid={`${handleId}${selected ? '-selected' : ''}`}
			id={handleId}
			style={{
				right: -6,
				minWidth: 12,
				height: '100%',
				borderRadius: 0,
				background: 'transparent',
				cursor: isConnected ? 'default' : 'crosshair',
				pointerEvents: isConnected ? 'none' : 'all',
				border: 'none',
				transform: 'none',
				top: 0,
				zIndex: 1,
				position: 'absolute',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center'
			}}
		>
			<Box
				width={6}
				height={6}
				bgcolor={color}
				data-testid={`${handleId}-dot`}
				borderRadius="100%"
				sx={{ pointerEvents: 'none' }}
			/>
		</Handle>
	);
};
